import type { LucideIcon } from 'lucide-react';
import { cn } from './cn';

export interface Onglet<T extends string> {
  id: T;
  libelle: string;
  icone: LucideIcon;
  compte?: number;
}

/** La barre d'onglets d'une fiche, sous son bandeau. */
export function Onglets<T extends string>({
  onglets,
  actif,
  onChoisir,
}: {
  onglets: readonly Onglet<T>[];
  actif: T;
  onChoisir: (id: T) => void;
}) {
  return (
    <div role="tablist" className="flex gap-1 overflow-x-auto border-t border-border-subtle px-4">
      {onglets.map((onglet) => {
        const Icone = onglet.icone;
        const choisi = onglet.id === actif;
        return (
          <button
            key={onglet.id}
            type="button"
            role="tab"
            aria-selected={choisi}
            onClick={() => {
              onChoisir(onglet.id);
            }}
            className={cn(
              'flex items-center gap-2 border-b-2 px-3 py-3.5 text-[13px] font-medium whitespace-nowrap transition',
              choisi
                ? 'border-primary text-primary'
                : 'border-transparent text-muted hover:text-ink'
            )}
          >
            <Icone className="size-4" aria-hidden />
            {onglet.libelle}
            {onglet.compte !== undefined ? (
              <span className="rounded-full border border-border px-1.5 text-[11px] text-muted">
                {onglet.compte}
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
